<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/21-FCP-update-your-resume-to-reflect-your-experience-and-new-skills.svg"
                class="img-fluid"
                alt="Assess your employability skills"
                srcset=""
              >
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md bg-img bg-img--future-career-21">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md-8 p-4">
          <p>After taking stock of the skills and competencies you’ve gained from your on-campus job, it’s important to incorporate them into your resume.</p>
          <p>There are several sections in your resume where you can highlight your on-campus work experience.</p>
          <ul>
            <li>Document on-campus employment activities under the <strong>work experience section</strong>. You may want to use the title, <em>Relevant Experience</em> for that section of your resume.</li>
            <li>On-campus experience can also be documented in the <strong>skills section</strong>.</li>
            <li>You might also choose to highlight some of your competencies or skills in your <strong>summary of qualifications section</strong>.</li>
          </ul>
          <p>The resume you use to attract employers should list the skills that you have developed most over the term of your on-campus employment.</p>
          <p>To determine which skills to highlight, review the job description, your work log and any feedback you noted following conversations with your supervisor.</p>
          <p>Learn more about updating your resume <router-link to="/job-search/04">here</router-link>.</p>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock
    // SidebarMenu,
    // Accordion
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
